var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarUnchecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15758"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 18151",
    style: {
      fill: "none",
      opacity: 0.1
    },
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11426",
    d: "M15.268 17.992a.861.861 0 0 1-.392-.093l-4.347-2.247L6.182 17.9a.861.861 0 0 1-.9-.065.837.837 0 0 1-.336-.827l.854-4.74L2.287 8.9a.834.834 0 0 1-.213-.842.85.85 0 0 1 .69-.572l4.858-.7 2.14-4.315a.857.857 0 0 1 1.534 0l2.165 4.31 4.858.7a.85.85 0 0 1 .69.572.834.834 0 0 1-.213.842l-3.511 3.365.853 4.74a.837.837 0 0 1-.341.842.86.86 0 0 1-.528.152z",
    transform: "translate(5.248 5.24)",
    style: {
      fill: "#4d4e52"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarUnchecked);
export default __webpack_public_path__ + "static/media/StarUnchecked.f1e99eef.svg";
export { ForwardRef as ReactComponent };